function instanceOfVariationGet200Response(value) {
  if (!("key" in value) || value["key"] === void 0) return false;
  if (!("variation" in value) || value["variation"] === void 0) return false;
  return true;
}
function VariationGet200ResponseFromJSON(json) {
  return VariationGet200ResponseFromJSONTyped(json);
}
function VariationGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    "key": json["key"],
    "variation": json["variation"]
  };
}
function VariationGet200ResponseToJSON(json) {
  return VariationGet200ResponseToJSONTyped(json, false);
}
function VariationGet200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
  if (value == null) {
    return value;
  }
  return {
    "key": value["key"],
    "variation": value["variation"]
  };
}
export {
  VariationGet200ResponseFromJSON,
  VariationGet200ResponseFromJSONTyped,
  VariationGet200ResponseToJSON,
  VariationGet200ResponseToJSONTyped,
  instanceOfVariationGet200Response
};
